import axios from 'axios' 

// X-Client: web tells the backend to answer with plain JSON instead of the encrypted
// format used by the outposts and desktop apps (see backend/utils/cryptoUtils.js)

export default axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL, 
    headers: { 'Content-Type': 'application/json', 'X-Client': 'web' },
    withCredentials: true
}) 

export const axiosPrivate = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL,
    headers: { 'Content-Type': 'application/json', 'X-Client': 'web' },
    withCredentials: true
}) 

export const axiosPublic = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL,
    headers: { 'Content-Type': 'application/json', 'X-Client': 'web' }
}) 

